import { createSelector } from '@ngrx/store';

export const getDataCyclesState = createSelector(
    (state: any) => state.dataCycles,
    (state: any) => state.get('list')
);

export const getCreateDataCycleState = createSelector(
    (state: any) => state.dataCycles,
    (state: any) => state.get('createDataCycle')
);

export const getUpdateDataCycleState = createSelector(
    (state: any) => state.dataCycles,
    (state: any) => state.get('updateDataCycle')
);

export const getSwitchDataCycleState = createSelector(
    (state: any) => state.dataCycles,
    (state: any) => state.get('switchDataCycle')
);
